import React, { useState } from "react";
import { Link }  from 'react-router-dom';
import { useHistory }  from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UIUtils from "utils/UIUtils";
import paramStore from "common/page/store/ParamStore";
import codeDataStore from "common/codedata/store/CodeDataStore";
function ContentsContainer() {
	const history = useHistory();
	const receivedData = paramStore.getParam("adm6710");
	const [FirmNM, SetFirmNM] = useState('')
	const [sheetId, setSheetId] = useState('');
	const [totalCnt, settotalCnt] = useState('');
	const [vBANK_CD, setBANK_CD] = useState('');
	const [vVAN_GB, setVAN_GB] = useState('');
	const [vFIRM_CD, setFIRM_CD] = useState('');	
	
    let data = {};
    let totalCnt_dev;
    let SheetData = {};
	
	var ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				/*
	            "SearchMode": 0,
	            "SectionCanResize": 1,
	            "CanSort": false,
	            "CanColMove": false,
	            "CanColResize": false,
	            "HeaderCheck": 0,
	            "CanEdit": 0,
	            "Hover": 0,
	            "Height": 500,
	            "InfoRowConfig": {
	                "Visible": false
	            },
            	*/
				"SearchMode": 1,
				"PageLength": 20,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate":"0",
				"Height": "auto",    
            	
			},
				//틀고정 좌측 컬럼 설정
			"Cols": [
	            {"Header": "NO",		"Type": "Int", 	"Name": "SEQ",			"Align": "Center",	"RelWidth": 1, 		"CanEdit": 0},
	            {"Header": "사업자번호",	"Type": "Text",	"Name": "BIZ_NO_DISP",	"Align": "Center",	"RelWidth": 1.5, 	"CanEdit": 0},
	            {"Header": "사업장",		"Type": "Text",	"Name": "BIZ_NM",		"Align": "left",	"RelWidth": 3,		"CanEdit": 0},
	            {"Header": "펌뱅킹별칭",	"Type": "Text",	"Name": "FIRM_NM",		"Align": "left",	"RelWidth": 2,		"CanEdit": 0},
	            {"Header": "은행",		"Type": "Text",	"Name": "BANK_NM",		"Align": "Center",	"RelWidth": 2,		"CanEdit": 0},
	            {"Header": "기관코드",		"Type": "Text",	"Name": "FIRM_CD",		"Align": "center",	"RelWidth": 1.5,	"CanEdit": 0},
	            {"Header": "VAN구분",		"Type": "Text",	"Name": "VAN_GB_NM",	"Align": "Center",	"RelWidth": 2,		"CanEdit": 0},
	            {"Header": "송신아이디",	"Type": "Text",	"Name": "SND_ID",		"Align": "left",	"RelWidth": 2,		"CanEdit": 0},
	            {"Header": "수신아이디",	"Type": "Text",	"Name": "RCV_ID",		"Align": "left",	"RelWidth": 2,		"CanEdit": 0},
	            {"Header": "BIZ_NO",	"Type": "Text",	"Name": "BIZ_NO",		"RelWidth": 0, Visible : 0},
	            {"Header": "BANK_CD",	"Type": "Text",	"Name": "BANK_CD",		"RelWidth": 0, Visible : 0},
	            {"Header": "VAN_GB",	"Type": "Text",	"Name": "VAN_GB",		"RelWidth": 0, Visible : 0},			
            ],
       
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				onClickSearch();
				
			},
			//시트 더블클릭시 이벤트 처리
			onDblClick:function(evtParam){
				onClickDetail();
		    },	

		},
		//시트객체 생성
		'create':function () {
			let options = this.init;
		
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'Main_sheet', // 생성할 시트의 id
				el: 'FirmList', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SheetData // 생성될 시트의 정적데이터
				
			});
			// global 변수 선언
			//@ts-ignore
		},

		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.Main_sheet.down2Excel({fileName: "펌뱅킹관리_"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
			
		},

	}

	React.useEffect(() => {
        codeDataStore.read("[BANK]");
        // @ts-egnore
		ib.create();

        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);
        }
    },[])
    
    //검색
    async function onClickSearch() {
        const response:any = await CommonUtil.execute({
            url:"adm_6710_r001",
            data: {
				"FIRM_NM": FirmNM.toUpperCase(),
			}
        })
        .then((response: any) => {          
			totalCnt_dev = String(Object.keys(response.REC).length);
			settotalCnt(totalCnt_dev);
			data = response.REC;
	
			// @ts-ignore
	        Main_sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			// @ts-ignore
	        Main_sheet.loadSearchData(data);  //data 로딩 처리
	         
       	}).catch((error) => {
        	CommonUtil.showAxiosError(error);
        	return;
        	
    	});	    
    	
    };  

    async function onClickRegist(event) {
    	event.preventDefault();		
	    let dataToSend = {};
	    // 다른 페이지로 이동하면서 데이터 전달
	    paramStore.setParam("adm6711", dataToSend);
	    
	    history.push({
	      pathname: 'adm6711',
	      state: { data: dataToSend }
	    });

    };    
    
    async function onClickDetail() {
        // @ts-ignore
		var row = Main_sheet.getFocusedRow();
		var vBIZ_NO_DISP = row["BIZ_NO_DISP"];
		var vBIZ_NM = row["BIZ_NM"];
		var vBANK_NM = row["BANK_NM"];
		var vFIRM_NM = row["FIRM_NM"];
		var vFIRM_CD = row["FIRM_CD"];
		var vVAN_GB_NM = row["VAN_GB_NM"];
		var vSND_ID = row["SND_ID"];
		var vRCV_ID = row["RCV_ID"];
		var vBIZ_NO = row["BIZ_NO"];
		var vBANK_CD = row["BANK_CD"];
		var vVAN_GB = row["VAN_GB"];
		
	    let dataToSend = {vBIZ_NO_DISP, vBIZ_NM, vBANK_NM, vFIRM_NM, vFIRM_CD, vVAN_GB_NM, vSND_ID, vRCV_ID, vBIZ_NO, vBANK_CD, vVAN_GB};
		paramStore.setParam("adm6713", dataToSend);	    
	    // 다른 페이지로 이동하면서 데이터 전달
	    history.push({
	      pathname: 'adm6713',
	      state: { data: dataToSend }
	    });

    };      
    
    async function onClickDelete() {
        // @ts-ignore		
		var row = Main_sheet.getFocusedRow();
		var vBANK_CD = row["BANK_CD"];
		var vVAN_GB = row["VAN_GB"];
		var vFIRM_CD = row["FIRM_CD"];
		
		if(await UIUtils.confirm('삭제하시겠습니까?')){
	        const response:any = await CommonUtil.execute({
	            url:"adm_6710_d001",
	        	data: {
					"BANK_CD" : vBANK_CD,
					"VAN_GB" : vVAN_GB,
					"FIRM_CD" : vFIRM_CD,	
				}
	       	})
        	.then((response: any) => {
				UIUtils.alert('정상처리되었습니다.').then();
				onClickSearch();			
        	}).catch((error) => {
            	CommonUtil.showAxiosError(error);
            	return;
        	});	        	        
		}
		
    };   
    
    const activeEnter = (e) => {
		if(e.key === "Enter") {
			onClickSearch();
		}
	}   
              
	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<ul className="fww-brd">
					<li><Link to="/admin/">홈</Link></li>
					<li><Link to="#">관리자페이지</Link></li>
					<li><Link to="#">시스템관리</Link></li>
					<li><Link to="#">펌뱅킹관리</Link></li>
				</ul>
				<main className="fww-main">
					<h1 className="tx tx-hd2">펌뱅킹관리</h1>
					<div className="sf sf-1row">
						<div className="inner">
							<div className="sf-item sf-m-1-3">
								<p className="sf-key">펌뱅킹 명칭</p>
								<div className="sf-value">
									<UIInput 
										className={'tf tf-md w100p'}
										value={FirmNM}
										valueChanged={(value) => SetFirmNM(value)}
										placeholder={"검색어 입력"}
										onKeyEnter={(e) => activeEnter(e)}/>
								</div>
							</div>
						</div>
						<Button color="pri" size="md" onClick={onClickSearch}>조회</Button>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총<em className="fw500">{totalCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							{/*<Button color="gray-o" size="sm" onClick={onClickDelete}>삭제</Button>*/}
							<Button color="pri-o" size="sm" onClick={onClickRegist}>등록</Button>
							<Button color="gray-o" size="sm" onClick={()=> ib.exportData()} >다운로드</Button>
						</div>
					</div>
					<div className="ibsheet" id= 'FirmList'></div>
				</main>
			</div>
		</PageContainer>
	);

}
export default ContentsContainer;
